"use client";
import Image, { ImageLoader, ImageProps } from "next/image";
import { buildCloudinaryUrl } from "./cloudinaryLoader";

const loader: ImageLoader = ({ src, width, quality }) =>
  buildCloudinaryUrl(src, { width, quality });

type Props = Omit<ImageProps, "src" | "loader"> & { publicId: string };

export default function CldImage({ publicId, ...rest }: Props) {
  return <Image loader={loader} src={publicId} {...rest} />;
}
